<template>
    <el-button style="margin-bottom: 15px; float: left;" type="primary" @click="dialogFormVisible = true">{{ $t('craft.addcraft', { msg: 'craft.addcraft' }) }}</el-button>
      <el-table
        :data="tableData"
        height="650"
        border
        style="width: 100%">
        <el-table-column
          prop="id"
          :label="$t('craft.id', { msg: 'craft.id' })"
          width="60">
        </el-table-column>
        <el-table-column
          prop="craftCode"
          :label="$t('craft.craftcode', { msg: 'craft.craftcode' })"
          width="120">
        </el-table-column>
        <el-table-column
          prop="craftDesc"
          :label="$t('craft.craftdesc', { msg: 'craft.craftdesc' })"
          width="280">
        </el-table-column>
        <!-- <el-table-column
          prop="processCode"
          label="工序代码"
          width="100">
        </el-table-column> -->
        <el-table-column
          prop="craftPrice"
          :label="$t('craft.craftprice', { msg: 'craft.craftprice' })"
          width="180">
        </el-table-column>
        <el-table-column
          prop="unit"
          :label="$t('craft.unit', { msg: 'craft.unit' })"
          width="180">
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('craft.createTime', { msg: 'craft.createTime' })"
          width="200">
        </el-table-column>
        <el-table-column
          prop="updateTime"
          :label="$t('craft.updateTime', { msg: 'craft.updateTime' })"
          width="200">
        </el-table-column>
        <el-table-column :label="$t('kbReview.table.opr', { msg: 'kbReview.table.opr' })" width="320" v-if="isAdmin">
              <template #default="scope">
                  <el-button
                      size="mini"
                      type="primary" 
                      icon="el-icon-edit"
                      @click="handleEdit(scope.$index, scope.row)">{{  $t('kbType.update', { msg: 'kbType.update' }) }}</el-button>
                  <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="handleDelete(scope.$index, scope.row.id)">{{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}</el-button>
              
              </template>
              </el-table-column>
      </el-table>
      <div class="pagination-tools">
              <!--
                  background:带背景的页码
                  layout：分页条布局
                      prev：上页按钮
                      pager：页码
                      next：下一页按钮
                      sizes:每页显示数量
                      jump：跳转到第几页
                      ->：定位其内容居右显示
                      total：总条目数
                  :page-size.sync="pageParam.pageSize":每页条目数   问题1
                  :current-page.sync="pageParam.pageNum"：当前页码  问题2
                  :page-sizes="pageSizes"：条目列表
                  :total="total"：总条目数
                  :hide-on-single-page="true":当只有一页时隐藏分页条
              -->
              <el-pagination
                  background
                  layout="sizes,prev, pager, next,jumper,->,total"
                  :page-size="this.pageParam.pageSize"
                  :current-page="this.pageParam.pageNum"
                  :page-sizes="pageSizes"
                  :total="total"
                  :hide-on-single-page="false"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :disabled="paginationDisabled"
              >
              </el-pagination>
        </div>  
        <!--添加工艺信息  -->
      <el-dialog :title=" $t('craft.addcraft', { msg: 'craft.addcraft' })" v-model="dialogFormVisible"  width="40%">
      <el-form :model="formInfo" :rules="rules" ref="formInfo" label-width="100px" >
        <el-form-item :label="$t('craft.craftcode', { msg: 'craft.craftcode' })" :label-width="formLabelWidth" prop="craftCode">
          <el-input v-model="formInfo.craftCode" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('craft.craftdesc', { msg: 'craft.craftdesc' })" :label-width="formLabelWidth" prop="craftDesc">
          <el-input v-model="formInfo.craftDesc" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="工序代码" :label-width="formLabelWidth" prop="processCode">
          <el-input v-model="formInfo.processCode" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('craft.craftprice', { msg: 'craft.craftprice' })" :label-width="formLabelWidth" prop="craftPrice">
          <el-input v-model="formInfo.craftPrice" autocomplete="off"></el-input>
        </el-form-item>
        <div style="text-align: left;">
        <el-form-item :label="$t('craft.unit', { msg: 'craft.unit' })" :label-width="formLabelWidth" prop="currencyId">
          <!-- <el-input v-model="formInfo.unit" autocomplete="off"></el-input> -->
          <el-select v-model="formInfo.currencyId" style="width: 100px;" :placeholder="$t('material.inctips', { msg: 'material.inctips' })">
        <el-option
          v-for="item in currencies"
          :key="item.id"
          :label="item.currency"
          :value="item.id">
        </el-option>
      </el-select>

      <span style="text-align: center; padding-left: 5px; padding-right: 5px;">/</span>

      <el-select v-model="formInfo.craftUnit" style="width: 100px;" placeholder="请选择">
        <el-option
          v-for="item in craftUnits"
          :key="item.id"
          :label="item.label"
          :value="item.label">
        </el-option>
        </el-select>

        </el-form-item>
        </div>
        <el-form-item >   
        <el-button type="primary" @click="addCraft('formInfo')" >{{  $t('material.add', { msg: 'material.add' }) }}</el-button>
        <el-button type="success" @click="resetForm('formInfo')">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' }) }}</el-button>
        <el-button @click="dialogFormVisible = false">{{ $t('kbType.cancel', { msg: 'kbType.cancel' }) }}</el-button> 
        </el-form-item>
      </el-form>  
    </el-dialog>
     <!--修改工艺信息  -->
     <el-dialog :title=" $t('craft.updatecraft', { msg: 'craft.updatecraft' })" v-model="dialogFormEditor"  width="40%">
      <el-form :model="formEdit" :rules="rules" ref="formEdit" label-width="100px" >
        <el-form-item  :label="$t('craft.craftcode', { msg: 'craft.craftcode' })" :label-width="formLabelWidth" prop="craftCode">
          <el-input v-model="formEdit.craftCode" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('craft.craftdesc', { msg: 'craft.craftdesc' })" :label-width="formLabelWidth" prop="craftDesc">
          <el-input v-model="formEdit.craftDesc" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="工序代码" :label-width="formLabelWidth" prop="processCode">
          <el-input v-model="formEdit.processCode" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('craft.craftprice', { msg: 'craft.craftprice' })" :label-width="formLabelWidth" prop="craftPrice">
          <el-input v-model="formEdit.craftPrice" autocomplete="off"></el-input>
        </el-form-item>
        <div style="text-align: left;">
        <el-form-item :label="$t('craft.unit', { msg: 'craft.unit' })" :label-width="formLabelWidth" prop="unit">
          <!-- <el-input v-model="formEdit.unit" autocomplete="off"></el-input> -->
          <el-select v-model="formEdit.currencyId" style="width: 100px;" :placeholder="$t('material.inctips', { msg: 'material.inctips' })">
          <el-option
            v-for="item in currencies"
            :key="item.id"
            :label="item.currency"
            :value="item.id">
          </el-option>
        </el-select>

        <span style="text-align: center; padding-left: 5px; padding-right: 5px;">/</span>

        <el-select v-model="formEdit.craftUnit" style="width: 100px;" placeholder="请选择">
          <el-option
            v-for="item in craftUnits"
            :key="item.id"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>

        </el-form-item>
        </div>
        <el-form-item >   
        <el-button type="primary" @click="editCraft('formEdit')" >{{  $t('kbType.update', { msg: 'kbType.update' }) }}</el-button>
        <el-button @click="dialogFormEditor = false">{{ $t('kbType.cancel', { msg: 'kbType.cancel' }) }}</el-button> 
        </el-form-item>
      </el-form>  
    </el-dialog>
  
    </template>
    
    <script>
    import { getRequest,postRequest,deleteRequest } from '../../axios/axios';
    import { baseUrl_New } from '../../axios/urlconfig';
      export default {
        data() {
          return {
            tableData: [
              // {id:'1',
              //  materialCode:'FT001',
              //  material:'铝棒',
              //  materialPrice:'4'},
            ],
            pageParam: {//分页参数
            pageNum: 1,//当前页
            pageSize: 10,//每页条目数据
          },
          total: 0,//总条目数
          pageSizes: [10, 20, 30, 40],//每页显示条目数列表
          isAdmin:sessionStorage.role.includes('超级管理员'),
          dialogFormVisible: false,
          formInfo: {
            craftCode: '',
            craftDesc: '',
            processCode:'',
            craftPrice: '',
            unit: '',  
            currencyId:'',
            craftUnit:'小时',
          },
          rules: {
            craftCode: [
          { required: true, message: this.$t('craft.incctips', { msg: 'craft.incctips' }), trigger: 'blur' },
          ],
          craftDesc: [
            { required: true, message: this.$t('craft.incdtips', { msg: 'craft.incdtips' }), trigger: 'blur' },
          ],
          processCode: [
            { required: true, message: this.$t('craft.incptips', { msg: 'craft.incptips' }), trigger: 'blur' },
          ],
          craftPrice: [
            { required: true, message: this.$t('craft.incptips', { msg: 'craft.incptips' }), trigger: 'blur' },
          ],
          unit: [
            { required: true, message: this.$t('craft.incutips', { msg: 'craft.incutips' }), trigger: 'blur' },
          ],
          currencyId:[
            { required: true, message: this.$t('material.inctips', { msg: 'material.inctips' }), trigger: 'blur' },
          ]
        },
        dialogFormEditor:false,
        currencies: [
        {
            id: '',
            currency: '',
            rate: '',
            abbreviation: '',
            createTime: '',
            updateTime: ''
        }
      ],
      craftUnits: [
        { id:'1',value: 'kg', label: '千克' },
        { id:'2',value: 'g', label: '克' },
        { id:'3',value: 'ton', label: '吨' },
        { id:'4',value: 'ci', label: '件' },
        { id:'5',value: 'ge', label: '个' },
        { id:'6',value: 'm*m', label: '平方米' },
        { id:'7',value: 'dm*dm', label: '平方分米' },
        { id:'8',value: 'm*m*m', label: '立方米' },
        { id:'9',value: 'dm*dm*dm', label: '立方分米' },
        { id:'10',value: 'h', label: '小时' },
        { id:'11',value: 'times', label: '次' },
      ],
        formEdit:{
          id:'',
          craftCode: '',
          craftDesc: '',
          processCode:'',
          craftPrice: '',
          unit: '',   
          currencyId:'',
          craftUnit:'',
        },
        
  
  
  
  
          }      
        },
  
        created(){
          this.getAllList();
          this.getCurrencyList();
         
        },
  
  
        methods: {
          getAllList(){//分页查询所有材料
          getRequest(baseUrl_New+'/craft/page/'+ this.pageParam.pageNum + '/' + this.pageParam.pageSize).then(response=>{
            //获得服务器端回传的map对象
            let resultMap = response;
              //从集合中获取用户列表及总条目数
              this.tableData = resultMap.list;
              this.total = resultMap.total;
          })
         },
         handleSizeChange(val) {
          // console.log(`每页 ${val} 条`);
          this.pageParam.pageSize = val;
          this.getAllList();
          },
          handleCurrentChange(val) {
          // console.log(`当前页: ${val}`);
          this.pageParam.pageNum = val;
          this.getAllList();
          },
          
          addCraft(formName){//添加物料信息
          this.$refs[formName].validate((valid) => {
          if (valid) {
            postRequest(baseUrl_New + '/craft/add', {
              craftCode:this.formInfo.craftCode,
              craftDesc:this.formInfo.craftDesc,
              processCode:this.formInfo.processCode,
              craftPrice:this.formInfo.craftPrice,
              //unit:this.formInfo.unit
              currencyId:this.formInfo.currencyId,
              craftUnit:this.formInfo.craftUnit,
            }).then(resp => {
              this.getAllList();
              this.dialogFormVisible= false,
              this.formInfo={},
              this.$message.success("添加成功");
            }).catch(err => {
              this.$message.error("添加工艺信息失败");
            })
          } else {
            return false;
          }
        });
          },
  
        resetForm(formName) {
          this.$refs[formName].resetFields();
        },
        handleDelete(index, id){
          this.$confirm( this.$t('kbReview.deleteMater', { msg: 'kbReview.deleteMater' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
              confirmButtonText: this.$t('addType.confirm', { msg: 'addType.comfirm' }),
              cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
              cancelButtonClass: 'btn-custom-cancel',
              type: 'warning'
          }).then(() => {
              deleteRequest(baseUrl_New + `/craft/del/${id}`)
              .then(response=>{
              this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))
              this.getAllList();
                                   
              })
          })
          },
          handleEdit(index, row){
          this.dialogFormEditor=true;
          this.formEdit = JSON.parse(JSON.stringify(row));
         },
         editCraft(formName){ //更新材料信息
          this.$refs[formName].validate((valid) => {
            if (valid) {
              var that = this
          postRequest(baseUrl_New + '/craft/update',{
              id:this.formEdit.id,
              craftCode:this.formEdit.craftCode,
              craftDesc:this.formEdit.craftDesc,
              processCode:this.formEdit.processCode,
              craftPrice:this.formEdit.craftPrice,
              //unit:this.formEdit.unit
              currencyId:this.formEdit.currencyId,
              craftUnit:this.formEdit.craftUnit,
          }).then(resp=>{
            this.getAllList(); 
            this.dialogFormEditor=false;
            this.formEdit={};
            this.$message.success("更新成功");
          }).catch(err => {
            this.$message.error("更新失败")
          })
            } else {
              
              return false;
            }
          });
         },
      getCurrencyList(){
      getRequest(baseUrl_New + '/rate/list').then(response => {
        //获得服务器端回传的map对象
        let resultMap = response;
        //从集合中获取用户列表及总条目数
        this.currencies = resultMap.list;
      });
     },
  
  
        
      }
        
      }
    </script>
  
  <style>
  
  </style>